import {AfterViewInit, Directive, ElementRef, HostListener, inject, Renderer2} from '@angular/core';

@Directive({
  selector: 'a[appLinkTabOpener]',
})
export class LinkTabOpenerDirective implements AfterViewInit {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  ngAfterViewInit() {
    this.checkLink();
  }

  @HostListener('mouseenter')
  @HostListener('click')
  checkLink() {
    const link: HTMLAnchorElement = this.el.nativeElement;
    const linkHref = link.getAttribute('href');

    if (!linkHref || linkHref.startsWith('/')) {
      return;
    }

    try {
      const protocolLink = this.ensureProtocolUrl(linkHref);
      link.setAttribute('href', protocolLink);

      const url = new URL(protocolLink);
      if (url.hostname !== window.location.hostname) {
        this.renderer.setAttribute(link, 'target', '_blank');
        this.renderer.setAttribute(link, 'rel', 'noopener noreferrer');
      }
    } catch (error) {
      console.error('Invalid URL:', linkHref, error);
      this.renderer.removeAttribute(link, 'href');
      this.renderer.addClass(link, 'cursor-not-allowed');
      this.renderer.setStyle(link, 'opacity', '0.5');
    }
  }

  ensureProtocolUrl(url: string): string {
    if (!url) {
      return '';
    }

    const protocolRegex = /^([a-z]+:)?\/\//i;
    if (protocolRegex.test(url)) {
      return url;
    }

    const relativeRegex = /^[/.]/;
    if (relativeRegex.test(url)) {
      return url;
    }

    return `https://${url}`;
  }
}
